




























































































































































import { Vue, Component } from "nuxt-property-decorator";
import LandingSiteCompanies from "~/components/LandingSiteCompanies.vue";
import GrPublicFooter from "~/components/startPageNew/GrPublicFooter.vue";
import CommonHelpers from "~/helpers/CommonHelpers";

@Component({
  components: { GrPublicFooter, LandingSiteCompanies },
  nuxtI18n: false,
})
export default class EngineerJobsPage extends Vue {
  tab = 0;

  get rootUrl(): string {
    return CommonHelpers.getBaseUrl();
  }

  get description(): string {
    return "Upptäck lediga ingenjörsjobb i hela Sverige. Fyll i dina kompetenser, löneanspråk och övriga preferenser och matchas mot företag som erbjuder det du söker!";
  }

  get title(): string {
    return "Ingenjörsjobb | Hitta jobb på dina egna villkor";
  }

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          property: "og:title",
          content: this.title,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:url",
          content: `${this.rootUrl}${this.$route.path}`,
        },
        {
          property: "og:description",
          content: this.description,
        },
        {
          name: "twitter:title",
          content: this.title,
        },
        {
          name: "twitter:description",
          content: this.description,
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
    };
  }

  get titleFontSize(): string {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
      case "sm":
        return "30px";
      case "md":
        return "40px";
      case "lg":
      case "xl":
        return "60px";
    }
  }

  get getStartedLink(): string {
    return this.localePath({
      name: "talentStart-createProfileStart",
    });
  }
}
